// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const CloudSetOption = (props) => {
    
    return (
        <Dialog header="雲層設定" visible={props.CloudSet} modal={false} position={'right'} keepInViewport={false} onHide={() => props.onHide('CloudSet')}>
            <Card>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">雲層高度：</label>
                    <div className="col-12 md:col-8">
                        <InputText value={props.height} onChange={(e) => props.setHeight(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">雲層厚度：</label>
                    <div className="col-12 md:col-8">
                        <InputText value={props.thickness} onChange={(e) => props.setThickness(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">密度剔除：</label>
                    <div className="col-12 md:col-8">
                        <InputText value={props.densityCutoff} onChange={(e) => props.setDensityCutoff(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">可視距離：</label>
                    <div className="col-12 md:col-8">
                        <InputText value={props.visibleDistance} onChange={(e) => props.setVisibleDistance(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">採樣值：</label>
                    <div className="col-12 md:col-8">
                        <InputText value={props.sampling} onChange={(e) => props.setSampling(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-3 md:mb-0">風速 X : </label>
                    <div className="col-12 md:col-3">
                        <InputText value={props.windSpeedX} onChange={(e) => props.setWindSpeedX(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                    <label class="col-12 mb-4 md:col-3 md:mb-0">風速 Y : </label>
                    <div className="col-12 md:col-3">
                        <InputText value={props.windSpeedY} onChange={(e) => props.setWindSpeedY(e.target.value)} style={{ width: "100%" }}/>
                    </div>
                </div>
            </Card>
        </Dialog>
    )
}